<template>
  <div class="index" @click="h5show = false">
    <div class="two-big-title">Experts Attending the Conference (To be updated)</div>
    <br>
    <div class="title-big">
      Plenary Speakers
    </div>
    <div class="index-con">
      <div class="people-lists">

        <div class="people-list" @click="lookFn(item, index)" v-for="(item, index) in speakList" :key="index">
          <div class="people-pic">
            <img v-if="item.image_url" :src="'https://www.fifs-isnff-2024.cn/public/' +
              item.image_url

              " alt="" />
          </div>
          <div class="peoples-title">
            <b>{{ item.news_title }}</b>
          </div>
          <div class="people-text">{{ item.writer }}</div>
          <div class="people-text text-999">{{ item.source }}</div>
        </div>

      </div>

      <div class="title-big">
        Other Experts Attending the Conference
      </div>
      <div class="index-con">
        <div class="people-lists">

          <div class="people-list" @click="lookFn(item, index)" v-for="(item, index) in speakListOther" :key="index">
            <div class="people-pic">
              <img v-if="item.image_url" :src="'https://www.fifs-isnff-2024.cn/public/' +
                item.image_url

                " alt="" />
            </div>
            <div class="peoples-title">
              <b>{{ item.news_title }}</b>
            </div>
            <div class="people-text">{{ item.writer }}</div>
            <div class="people-text text-999">{{ item.source }}</div>
          </div>

        </div>

      </div>
    </div>

    <el-drawer size="50%" :visible.sync="drawer" :direction="direction">
      <!-- 
      :with-header="false" -->
      <div style="
          padding: 0px 20px 20px;
          box-sizing: border-box;
          overflow-y: auto;
          height: calc(100vh - 80px);
          box-sizing: border-box;
        " class="aaa">
        <div class="title" style="font-size: 22px; margin-bottom: 15px">
          {{ title }}
        </div>
        <div style="
            padding: 10px;
            text-indent: 2em;
            color: #333;
            font-size: 14px;
            line-height: 1.9;
          " v-html="content"></div>
      </div>
    </el-drawer>
  </div>
</template>


<script>
export default {
  data() {
    return {
      speakList: [],
      speakListOther: [],
      content: "",
      direction: "rtl",
      drawer: false,
      h5show: false,
    };
  },
  mounted() {
    this.getspeakList();
    this.getspeakListOther();
  },
  methods: {
    lookFn(item, index) {
      if (item.news_content) {
        this.drawer = true;
        this.content = item.news_content;
        this.title = item.news_title;
      }
    },
    getspeakList() {
      var that = this;
      var params = {
        type_id: 830,
      };
      this.$http.speaker_list(params).then((res) => {
        that.speakList = res.data;
      });
    },
    getspeakListOther() {
      var that = this;
      var params = {
        type_id: 831,
      };
      this.$http.speaker_list1(params).then((res) => {
        that.speakListOther = res.data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.people-lists {
  display: flex;
  padding-bottom: 60px;
  flex-wrap: wrap;
}

.user-lists {
  padding: 50px 0;
}

.user-list {
  display: flex;
  margin-bottom: 30px;
  padding: 10px 0 10px 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.users-title {
  margin-right: 20px;
}

.people-list {
  width: 16.6%;
  padding: 0 10px;
  box-sizing: border-box;
  margin-top: 20px;
  text-align: center;
  cursor: pointer;
}

.people-list-pic {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  margin: 0 auto 10px;
  background: #666;
  border: 2px solid #333;
}


.people-pic {
  width: 110px;
  height: 150px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #ccc;
  // background: #ddd;
  margin: 0 auto;
  border-radius: 4px;
}

.people-pic img {
  width: auto;
  height: 100%;
}

.people-list-title {
  margin-bottom: 3px;
}

.people-list-text {
  font-weight: 600;
}

.people-list-pic img {
  width: auto;
  height: 110%;
}

.index {
  .index-con {
    min-height: 600px;
  }

  .bottom_span {
    height: 2px;
    background: #28d6ec;
    width: 100%;
    margin-bottom: 100px;
    margin-top: 60px;
  }

  .title-big {
    color: #595959;
    font-size: 20px;
    font-weight: 600;

    align-items: center;
    margin-bottom: 14px;
    margin-top: 14px;
    text-align: center;
  }

  .lists {
    .text {
      font-size: 14px;
      margin-bottom: 40px;
      margin-top: 20px;
      font-weight: 500;
      line-height: 1.8;
    }

    .list {
      margin-top: 20px;
      width: 100%;
    }

    .name {
      font-weight: 600;
      text-align: center;
      margin-bottom: 5px;
    }

    .pic {
      width: 140px;
      display: block;
      margin: 0 auto 10px;
    }
  }

  .index-con {
    max-width: 1200px;
    margin: 0 auto;
  }

  .my-title {
    color: #28d6ec;
    font-size: 18px;
    margin: 40px 0;
    font-weight: 500;
  }
}

@media screen and (max-width: 768px) {

  .index-con,
  .people-list {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/committee.vue